import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

import { Button, Alert } from 'antd';
import Summary from 'components/Summary/Summary';
import FormConfig from 'components/Form/Form.config';
import HeaderForm from 'components/Form/HeaderForm';
import { submitData, resetForm } from 'modules/userrequest';
import { getAnswerDelay, getUserrequestSchema, getAllActivitiesDates } from 'helpers/activityHelpers';

import { activitiesHasNightEvent, getFirstDateFromActivities } from 'helpers/incidencePeriodHelpers';
import SuccessModal from './SuccessModal';

class FormSummary extends React.Component {
  handleAction = () => {
    // Reset form to initial value
    this.props.resetForm();
    this.props.history.push('/manage-request');
  }

  submitForm = () => {
    const { userrequest, userrequest: { properties }, activityTypes } = this.props;
    const firstEventDate = getFirstDateFromActivities(properties.activities);
    const hasNightEvent = activitiesHasNightEvent(properties.activities);

    const data = {
      ...userrequest,
      properties: {
        ...properties,
        firstEventDate,
        hasNightEvent,
        activityTypes: getUserrequestSchema(properties.activities, activityTypes),
      },
    };
    this.props.submitData({ data });
  }

  render () {
    const { userrequest, userrequest: { isSaving }, form } = this.props;
    const answerDelay = getAnswerDelay(userrequest.properties.activities);
    const answerDelayDynamic = Math.floor(
      getAllActivitiesDates(userrequest.properties.activities)
        .reduce((min, item) => Math.min(min, moment.duration(moment(item.startDate).diff(moment())).as('d')), 30),
    );

    return (
      <div>
        <HeaderForm showDraft showSubmit />
        <Summary data={userrequest} />
        {!form.valid && form.error && (
          <Alert
            style={{ marginTop: 16 }}
            message={form.error}
            description={FormConfig.confirmation.errorText}
            type="error"
            showIcon
          />
        )}
        {answerDelay && (
          <Alert
            style={{ marginTop: 16 }}
            message={
              answerDelay === true
                ? (
                  <p>
                  Compte tenu des informations que vous avez indiquées,
                  sans réponse de l&apos;ONF dans un délai de {answerDelayDynamic} jours,
                  votre demande d&apos;autorisation sera considérée comme acceptée.
                  </p>
                )
                : (
                  <p>
                  Compte tenu des informations que vous avez indiquées,
                  vous aurez une réponse de l&apos;ONF maximum {answerDelay} jours avant
                  la date de votre manifestation.
                  </p>
                )
            }
          />
        )}
        <div style={{ margin: '24px 0', textAlign: 'right' }}>
          <Button
            size="large"
            onClick={this.props.editForm}
            style={{ marginRight: 8 }}
          >
            {FormConfig.confirmation.editButton}
          </Button>
          <Button
            type="primary"
            icon="arrow-right"
            size="large"
            onClick={this.submitForm}
            htmlFor="submit"
            loading={isSaving === true}
          >
            {FormConfig.confirmation.submitButton}
          </Button>
        </div>

        <SuccessModal
          visible={form.submitted}
          handleAction={this.handleAction}
          expirationDate={userrequest.expiry}
          expirationDateDynamic={answerDelayDynamic}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userrequest: state.userrequest,
  form: state.forms.userrequest.$form,
  activityTypes: state.admin.activities.list,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  submitData,
  resetForm,
}, dispatch);

FormSummary.propTypes = {
  editForm: PropTypes.func.isRequired,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FormSummary));



// WEBPACK FOOTER //
// ./src/components/Form/FormSummary.js